import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Spinner,
  Stack,
} from '@chakra-ui/react'
import * as global from 'brokertslib/src/helpers/global'
import { AxiosError } from 'axios'
import { Addon, InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { useContext, useEffect } from 'react'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { useGetAddons, useUpdateAddons } from '../hooks/useWizard'
import { Save } from '../icons'
import { insuranceParamsContext } from '../layouts/Wizard'
import { useSelections } from '../hooks'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'
import ErrorSummary from '../components/ErrorSummary'
import { ExtraInsuranceCar } from './ExtraInsuranceCar'
import { carkulkaOffersContext } from '../context/CarkulkaOffersProvider'

export const ExtraInsuranceModal = ({
  isOpen = false,
  onClose,
  children
}: {
  isOpen: boolean
  onClose: () => void
  children?: React.ReactNode
}) => {
  const { data: dataPf, isLoading: isLoadingPf, isFetching: isFetchingPf } = useSelections(SelectionType.FrekvencePlatby)
  const { insuranceParams: insuranceParamsGeneric, refetchInsuranceParams, insuranceParamsId } = useContext(insuranceParamsContext)
  let insuranceParams = insuranceParamsGeneric as InsuranceParamsDto

  const { recalculateOffers: recalculate, offers } = useContext(carkulkaOffersContext)

  const { mutateAsync: updateAddons, isLoading: isSaving } = useUpdateAddons(insuranceParamsId!)

  const methods = useForm<InsuranceParamsDto>({
    defaultValues: insuranceParams,
    // resolver: yupResolver(schema),
    mode: 'onBlur'
  })

  const { handleSubmit, control, getValues, setValue, setError, formState: { errors }, reset, watch } = methods
  const { data: addons, refetch: refetchAddons } = useGetAddons(insuranceParamsId!, { enabled: false, onSuccess: ({ data }) => { setValue('addons', data) } })
  useEffect(() => { if (!!insuranceParamsId) refetchAddons() }, [insuranceParamsId]);

  const closeModal = (doReset: boolean) => {
    if (doReset) {
      reset() // reset volat pouze pokud se neukládají hodnoty
    }
    onClose()
  }

  const submitForm = handleSubmit((values) => {
    let request = {
      addons: values.addons,
      paymentFrequency: values.generalParams.paymentFrequency
    }
    updateAddons(request)
      .then(() => {
        recalculate(offers?.map(of => of.offerId))
        refetchInsuranceParams()
        refetchAddons() // aby se prenacetla cache
        closeModal(false)
      })
      .catch((err: AxiosError<any>) => {

        if (!(err.response && err.response.status === 400 && err.response.data))
          return;

        let data = err.response.data

        // zobrazeni serverove validace
        Object.keys(data).forEach((x: any) => {
          setError(global.toCamelCase(x), { message: data[x].join(' ') })
        })

        alert('Při ukládání došlo k chybě')
      })
  })

  const setAddon = (addon: Addon) => {
    var addons = getValues('addons') ?? []
    var index = addons.findIndex(x => x.riskId === addon.riskId)
    if (index < 0) addons.push(addon)
    else addons[index] = addon
    setValue('addons', addons)
  }

  return (
    <Modal size="6xl" onClose={() => closeModal(true)} isOpen={isOpen}>
      <ModalOverlay />
      <FormProvider {...methods}>
        <form onSubmit={submitForm}>
          <ModalContent>
            <ModalHeader>Nastavení parametrů pro všechny nabídky</ModalHeader>
            <ModalBody>
              <Box sx={{ display: 'grid', gap: 8, justifyContent: 'start' }}>
                {/* generalParams.paymentFrequency */}
                <FormControl isInvalid={!!errors.generalParams?.paymentFrequency}>
                  <Stack direction={'row'}>
                    <FormLabel htmlFor="generalParams.paymentFrequency">Frekvence plateb</FormLabel>

                    {(isFetchingPf || isLoadingPf) && <Spinner />}
                  </Stack>

                  <Controller
                    name="generalParams.paymentFrequency"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <RadioGroup onChange={e => onChange(parseInt(e))} value={value?.toString() ?? ''}>
                        <Stack direction="column" spacing={4}>
                          {dataPf?.data
                            ?.filter(x => x.id != Selection.OneTime)
                            .map((item) => (
                              <Radio value={item.id.toString()} key={item.id.toString()}>
                                {item.description}
                              </Radio>
                            ))}
                        </Stack>
                      </RadioGroup>
                    )}
                  />
                </FormControl>

                <ExtraInsuranceCar addons={addons?.data ?? []} changeAddon={setAddon} />

                {children && children}
              </Box>
            </ModalBody>
            <ModalFooter flexDirection='column-reverse' alignItems='flex-end'>
              <Button colorScheme="primary" onClick={submitForm} isLoading={isSaving} isDisabled={isSaving}>
                <Save />
                Uložit a přepočítat
              </Button>

              <ErrorSummary errors={errors} />
            </ModalFooter>
          </ModalContent>
        </form>
      </FormProvider>
    </Modal>
  )
}
